import type { Result } from '@schibsted-nmp/search-frontend-clients/suggest';
import React from 'react';
import { useAppConfig } from '../AppConfig';
import { SearchboxOption } from '../searchbox/SearchboxOption';

type ResultOptionProps = {
    children?: React.ReactNode | ResultOptionRenderProp;
    className?: string;
    linkClass?: string;
    result: Result;
};

type ResultOptionRenderProp = (args: {
    active: boolean;
    ariaLabel: string;
    disabled: boolean;
    selected: boolean;
}) => JSX.Element;

export function ResultOption(props: ResultOptionProps) {
    const { children, className = '', linkClass, result } = props;

    const ariaLabel = getAriaLabel(result);
    const hasRenderProp = typeof children === 'function';

    const { isLandingPage } = useAppConfig();
    const optionClass = isLandingPage ? 'sm:px-8 sm:py-4 sm:my-0' : '';

    return (
        <SearchboxOption
            ariaLabel={ariaLabel}
            className={`${optionClass} ${className}`}
            value={result}
        >
            {hasRenderProp ? (
                ({ active, disabled, selected }) =>
                    children({
                        active,
                        ariaLabel,
                        disabled,
                        selected,
                    })
            ) : (
                <a
                    aria-label={ariaLabel}
                    className={`${linkClass} s-text`}
                    href={isLandingPage ? result.url : undefined}
                >
                    {children}
                </a>
            )}
        </SearchboxOption>
    );
}

function getAriaLabel(result: Result) {
    const title = [result.title, result.secondaryTitle]
        .filter(Boolean)
        .join(' - ');
    return [result.groupingHeader, title, result.info1, result.info2]
        .filter(Boolean)
        .join(', ');
}
